import React from 'react';

interface EditLabelModalProps {
  show: boolean;
  value: string;
  error: string;
  isLoading: boolean;
  onChange: (val: string) => void;
  onClose: () => void;
  onSubmit: () => void;
  disableSave: boolean;
  labelName?: string;
}

const EditLabelModal: React.FC<EditLabelModalProps> = ({
  show,
  value,
  error,
  isLoading,
  onChange,
  onClose,
  onSubmit,
  disableSave,
  labelName
}) => {
  if (!show) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.3)', zIndex: 2000,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{ background: '#fff', padding: '24px 32px', borderRadius: 8, minWidth: 340, boxShadow: '0 4px 24px #0003', position: 'relative', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
          <span style={{ fontWeight: 700, fontSize: 18, color: '#222' }}>{labelName ? `Edit ${labelName} Label` : 'Edit Label'}</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 22, color: '#888', cursor: 'pointer', lineHeight: 1, padding: 0 }} aria-label="Close">&times;</button>
        </div>
        <input
          style={{ width: '100%', padding: '10px 12px', fontSize: 15, marginBottom: 18, border: '1px solid #d3d3d3', borderRadius: 4, background: '#fff', color: '#222' }}
          type="text"
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="Update label value"
          autoFocus
        />
        {error && <div style={{ color: 'red', fontSize: 13, marginBottom: 8 }}>{error}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 0, marginTop: 8 }}>
          <button onClick={onClose} style={{ padding: '7px 16px', borderRadius: 4, border: '1px solid #d3d3d3', background: '#fff', color: '#222', fontWeight: 500, cursor: 'pointer', marginRight: 8 }}>Cancel</button>
          <button
            className="btn btn-primary"
            style={{ padding: '7px 16px', borderRadius: 4, fontWeight: 500, marginLeft: 0 }}
            disabled={disableSave || isLoading}
            onClick={onSubmit}
          >{isLoading ? 'Saving...' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
};

export default EditLabelModal;